import React from "react";
import { TransformedCheckoutData } from "../../../types/checkoutApiTypes";
import { TransformedCart } from "../../../../cart/types/cartApiTypes";
import AddressSummary from "./AddressSummary";
import ItemsSummary from "./ItemsSummary";

interface OrderReviewProps {
  checkoutData: TransformedCheckoutData | undefined;
  cartData: TransformedCart | undefined;
  onEditBilling: () => void;
  onEditShipping: () => void;
}

const OrderReview: React.FC<OrderReviewProps> = ({
  checkoutData,
  cartData,
  onEditBilling,
  onEditShipping,
}) => {
  return (
    <div className="order-review">
      <AddressSummary
        checkoutData={checkoutData}
        cartData={cartData} // Pass cartData here
        onEditBilling={onEditBilling}
        onEditShipping={onEditShipping}
      />
      <ItemsSummary cartData={cartData} />
    </div>
  );
};

export default OrderReview;
